import { Component } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireStorage } from 'angularfire2/storage';

export interface Image {
  id: string;
  image: string;
}
@Component({
  selector: 'page-submit-attachments',
  templateUrl: 'submit-attachments.html',
})
export class SubmitAttachmentsPage {

  url: any;
  newImage: Image = {
    id: this.afs.createId(), image: ''
  }
  loading: boolean = false;;

  constructor(private afs: AngularFirestore, private storage: AngularFireStorage) { }

  uploadImage(event) {
    console.log(event);
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      // For Preview Of Image
      reader.onload = (e:any) => { // called once readAsDataURL is completed
        this.url = e.target.result;
        // For Uploading Image To Firebase
        const fileraw = event.target.files[0];
        console.log(fileraw)
        const filePath = '/Image/' + this.newImage.id + '/' + 'Image' + (Math.floor(1000 + Math.random() * 9000) + 1);
        const result = this.SaveImageRef(filePath, fileraw);
        const ref = result.ref;
        result.task.then(a => {
          ref.getDownloadURL().subscribe(a => {
            console.log(a);
            this.newImage.image = a;
            this.loading = false;
          });
          this.afs.collection('Image').doc(this.newImage.id).set(this.newImage);
        });
      }, error => {
        console.log(error);
      }

    }
  }



  SaveImageRef(filePath, file) {

    return {
      task: this.storage.upload(filePath, file)
      , ref: this.storage.ref(filePath)
    };
  }
}


// WEBPACK FOOTER //
// ./src/pages/submit-attachments/submit-attachments.ts